/**
* 图表界面
*/
<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据可视化</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row class="jinggao" v-show="jinggao">
    <el-alert
        title="未选择任何活码"
        type="warning"
        effect="light"
        center
        show-icon>
      </el-alert>
    </el-row>
    <div id="box">
    <!-- 搜索，切换 -->
    <el-row :gutter="23">
      <el-col :span="10">
        <el-radio-group v-model="shijianduan" @change="selectRiqi">
          <el-radio-button label="今日"></el-radio-button>
          <el-radio-button label="昨日"></el-radio-button>
          <el-radio-button label="最近7天"></el-radio-button>
          <el-radio-button label="最近30天"></el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col :span="4">
        <el-select v-model="qr_id" placeholder="请选择活码" @change="changeqrid">
          <el-option
            v-for="item in huoma"
            :key="item.qr_id"
            :label="item.qr_title"
            :value="item.qr_id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <!-- 统计图 -->
    <el-row :gutter="23">
      <el-col :span="24" class="text-c">
        <div class="st-gbox">
          <div class="cavasbox" ref="SUMEchart"></div>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-table
            :data="tableData"
            style="width: 100%;margin-left: 30px;">
            <el-table-column
              prop="shijian"
              label="时间"
              width="100">
            </el-table-column>
            <el-table-column
              prop="fwl"
              label="访问量"
              width="300">
            </el-table-column>
            <el-table-column
              prop="sbl"
              label="识别量"
              width="300">
            </el-table-column>
            <el-table-column
              label="流失量"
              width="300">
              <template slot-scope="scope">
                {{scope.row.fwl - scope.row.sbl}}
              </template>
            </el-table-column>
          </el-table>
    </el-row>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import Chart from 'echarts'
import { qrList, hourTongji, dayTongji } from '../../api/userMG'
export default {
  name: "welcome",
  data() {
    return {
      jinggao: false,
      shijianduan: '今日',
      qr_id: '',
      huoma: [],
      tableData: [],
      //  销售总金额
      SUMoption: {
        tooltip: {
          trigger: 'item',
          formatter: "{a} <br/>{b}点 : {c}"
        },
        legend: {
          data: [{
            name: '访问量',
            icon: 'rect'
          }, {
            name: '识别量',
            icon: 'rect'
          }],
          top: 1,
          left: 1,
          itemGap: 10,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#323232"
          }
        },
        grid: {
          left: 50,
          right: 10,
          top: 30,
          bottom: 30,
          borderWidth: 1
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1
            }
          },
          axisLabel: {
            margin: 14,
            height: 70,
            interval: 0,
            textStyle: {
              fontSize: 10,
              color: "#999999"
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: "#999999",
              width: 1
            }
          },
          axisLabel: {
            margin: 14,
            textStyle: {
              fontSize: 10,
              color: "#999999"
            }
          }
        },
        series: [{
          name: '访问量',
          //   type: 'bar',
          type: 'line',
          barGap: 0,
          data: [],
          barWidth: 10,
          itemStyle: {
            color: "#108ff9"
          }
        }, {
          name: '识别量',
          //   type: 'bar',
          type: 'line',
          barGap: 0,
          data: [],
          barWidth: 10,
          itemStyle: {
            color: "#ff007f"
          }
        }]
      }
    }
  },
  // 导入组件
  components: {
    // 点聚合组件
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.qr_id = this.$route.params.qr_id
    this.getdata({})
    if(this.qr_id == undefined){
      this.jinggao = true
    }else{
      this.getHourlist({qr_id: this.qr_id,riqi: this.shijianduan})
    }
  },
  // 挂载结束状态(里面是操作)
  mounted() {

  },
  // 里面的函数只有调用才会执行
  methods: {
    // 交易总金额
    getSUM() {
      this.chart = Chart.init(this.$refs.SUMEchart)
      this.chart.setOption(this.SUMoption)
    },
    // 获取活码列表
    getdata(parameter) {
      /***
       * 调用接口
       */
      qrList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.huoma = res.data
          }
        })
        .catch(err => {
          this.$message.error('活码加载失败，请稍后再试！')
        })
    },
    //获取小时统计（今日、昨日24小时区段统计）
    getHourlist(parameter){
      hourTongji(parameter).then(res=>{

        this.SUMoption.xAxis.data = res.x
        this.SUMoption.series[0].data = res.data
        this.SUMoption.series[1].data = res.shibiedata
        this.tableData = res.tabledata
        this.getSUM()
      }).catch(err=> {

      })
    },
    //获取日统计（近7天、30天区段统计）
    getDaylist(parameter){
      dayTongji(parameter).then(res=>{
        console.log(res)
        this.SUMoption.xAxis.data = res.x
        this.SUMoption.series[0].data = res.data
        this.SUMoption.series[1].data = res.shibiedata
        this.tableData = res.tabledata
        this.getSUM()
      }).catch(err=> {
        console.log('cuowu')
      })
    },
    //选择日期
    selectRiqi(res) {
      if(res == '今日' || res == '昨日'){
        this.getHourlist({qr_id: this.qr_id,riqi: this.shijianduan})
      }else{
        this.getDaylist({qr_id: this.qr_id,riqi: this.shijianduan})
      }
    },
    //选择活码
    changeqrid(res){
      this.qr_id = res
      this.shijianduan = '今日'
      this.getHourlist({qr_id: this.qr_id,riqi: this.shijianduan})
    }
  },
  watch: {
    qr_id:function(val){
      if(val > 0){
        this.jinggao = false
      }
    }
  }
};
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
#box {
  padding: 20px;
}
.stbgc {
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
  padding: 0px 16px;
}
.stsearch {
  text-align: center;
}
.text-c {
  text-align: center;
}
.st-gbox {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 5px;
  height: 30vh;
  box-sizing: border-box;
  padding: 10px;
}
.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.paybox {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 5px;
  margin-top: 20px;
  height: 32vh;
}
.jinggao {
  padding: 0 25%;
}
</style>



// WEBPACK FOOTER //
// src/views/charts/statistics.vue